import { render, staticRenderFns } from "./EditarCobro.vue?vue&type=template&id=0e416549&scoped=true"
import script from "./EditarCobro.vue?vue&type=script&lang=js"
export * from "./EditarCobro.vue?vue&type=script&lang=js"
import style0 from "./EditarCobro.vue?vue&type=style&index=0&id=0e416549&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e416549",
  null
  
)

export default component.exports